import React from 'react'
import './index.scss'

export const FooterPage = () => {
  return (
    <div className="footer">created by <span>ardanclassic</span></div>
  )
}

export default FooterPage